import React from 'react'
import AppLayout from '../../../../../layout/components/AppLayout'

function HolidayListPage() {
  return (
    <AppLayout>
    <div>HolidayListPage</div>
    </AppLayout>
  )
}

export default HolidayListPage